import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import TgBringModelDarkIcon from "../../..//assets/TailoredGeneration/icons/api-upload-model.svg";
import TgIntegrateAPIIcon from "../../..//assets/TailoredGeneration/icons/tg-integrate-api.svg";
import TgTrainAPIIcon from "../../..//assets/TailoredGeneration/icons/tg-train-api.svg";
import TgTrainConsoleIcon from "../../..//assets/TailoredGeneration/icons/tg-train-console.svg";
import copyApiImage from "../../..//assets/TailoredGeneration/images/tg-overview.png";
import DemoIcon from "../../..//assets/common/icons/demo.svg";
import IframeIcon from "../../..//assets/common/icons/enable-iframe.svg";
import TgBringModelIcon from "../../../assets/TailoredGeneration/icons/api-download-model.svg";
import IntegrateProductsIcon from "../../../assets/images/svgs/IntegrateProducts.svg";
import ConsoleOverviewCards from "../../../components/Home/Overview/Cards/ConsoleOverviewCards";
import ConsoleOverviewLayout from "../../../components/Home/Overview/Layout/ConsoleOverviewLayout";
import LinkConstants from "../../../constants/LinkConstants";
import RouterConstants from "../../../constants/RouterConstants";

const TgOverview = () => {
	const { t } = useTranslation("translation", { keyPrefix: "newTg.overview" });
	const cards = [
		{
			key: "console",
			icon: TgTrainConsoleIcon,
			title: t("cards.console.title"),
			description: t("cards.console.description"),
			link: RouterConstants.NEW_TG.PROJECTS.fullPath,
		},
		{
			key: "trainApi",
			icon: TgTrainAPIIcon,
			title: t("cards.trainApi.title"),
			description: t("cards.trainApi.description"),
			link: LinkConstants.TG.TRAINING.DOCS,
			newTab: true,
		},
		{
			key: "generateApi",
			icon: TgIntegrateAPIIcon,
			title: t("cards.generateApi.title"),
			description: t("cards.generateApi.description"),
			link: LinkConstants.TG.GENERATION.DOCS,
			newTab: true,
		},
		{
			key: "demo",
			icon: DemoIcon,
			title: t("cards.demo.title"),
			description: t("cards.demo.description"),
			link: RouterConstants.NEW_TG.DEMO.fullPath,
		},
		{
			key: "iframe",
			icon: IframeIcon,
			title: t("cards.iframe.title"),
			description: t("cards.iframe.description"),
			link: RouterConstants.ACCOUNT_IFRAMES.fullPath,
			newTab: true,
		},
		{
			key: "downloadModel",
			icon: TgBringModelIcon,
			title: t("cards.downloadModel.title"),
			description: t("cards.downloadModel.description"),
			link: LinkConstants.TG.DOWNLOAD_MODEL.DOCS,
			newTab: true,
		},
		{
			key: "bringModel",
			icon: TgBringModelDarkIcon,
			title: t("cards.bringModel.title"),
			description: t("cards.bringModel.description"),
			link: LinkConstants.TG.UPLOAD_MODEL.DOCS,
			newTab: true,
		},
		{
			key: "integrate",
			icon: IntegrateProductsIcon,
			title: t("cards.integrate.title"),
			description: t("cards.integrate.description"),
			link: LinkConstants.TG.GENERATION.DOCS,
			newTab: true,
		},
	];

	return (
		<ConsoleOverviewLayout
			copyApiTokenProps={{
				image: copyApiImage,
				description: t("copyApiToken.description"),
			}}
			integrations={["COMFY_UI", "FIGMA", "PHOTOSHOP", "COPILOT", "POWERPOINT"]}
		>
			<ConsoleOverviewCards cards={cards} />
		</ConsoleOverviewLayout>
	);
};

export default observer(TgOverview);
